import { ApiService } from './ApiService';
import { IGetOneResponse } from '../util/Types/Generic';
// import { User } from '../Utilis/Types/User';
export class MailService extends ApiService {
  static pathName = 'mail';

  static send = (body: {
    emails: string[];
    subject?: string;
    text: string;
    flowId: string;
    urls?: string[];
    callbackUrl?: string;
    useTemplate?: boolean;
  }): Promise<IGetOneResponse<any>> => {
    return ApiService.post(`${this.pathName}/send`, {
      ...body,
      callBackUrl: body.callbackUrl,
    });
  };

  static sendGmail = (body: {
    to: string[];
    subject: string;
    text: string;
    html?: string;
    attachments?: string[];
    callBackUrl?: string;
    userEmail?: string;
    useTemplate?: boolean;
  }): Promise<IGetOneResponse<any>> => {
    return ApiService.post(`${this.pathName}/send-gmail`, body);
  };

  static sendMicrosoft = (body: {
    to: string[];
    subject: string;
    text: string;
    html?: string;
    attachments?: string[];
    callBackUrl?: string;
    useTemplate?: boolean;
  }): Promise<IGetOneResponse<any>> => {
    return ApiService.post(`${this.pathName}/send-microsoft`, body);
  };
}
